/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["iframe[_ngcontent-%COMP%]{height:800px;width:80%}body[_ngcontent-%COMP%]{height:10000px}[_nghost-%COMP%]     .mat-tab-header{top:0;z-index:1000;position:sticky;position:-webkit-sticky}.free[_ngcontent-%COMP%]{font-weight:lighter;font-style:italic}.train-ticket-price[_ngcontent-%COMP%]{color:red;font-weight:700}.train-ticket-seat[_ngcontent-%COMP%]{display:flex;align-items:center;border-radius:5px;padding:3px;margin:2px;box-shadow:0 0 1px 0 #474747}"];
export { styles as styles };
